const TheContainer = () => import("@/containers/TheContainer.vue")
const ChargebackList = () => import("./ChargebackList.vue")
const ChargebackDetail = () => import("./ChargebackDetail.vue")

export default [
    // Admin (global scope)
    {
        path: '/admin/chargebacks',
        component: TheContainer,
        meta: { perms: ['admin.accounting.chargeback.list'] },
        children: [
            {
                path: '',
                name: 'admin.chargebacks',
                component: ChargebackList,
                meta: {
                    label: 'Chargebacks',
                    scopeType: 'global',
                    permission: 'admin.accounting.chargeback.list'
                },
            },
            {
                path: ':id',
                name: 'admin.chargebacks.detail',
                component: ChargebackDetail,
                meta: {
                    label: 'Chargeback Detail',
                    scopeType: 'global',
                    permission: 'admin.accounting.chargeback.detail'
                },
            },
        ]
    },

    // Contract Manager scope
    {
        path: '/contract-manager/:contractManagerId/chargebacks',
        component: TheContainer,
        meta: { perms: ['contract_manager.accounting.chargeback.list'] },
        children: [
            {
                path: '',
                name: 'contractManager.chargebacks',
                component: ChargebackList,
                meta: {
                    label: 'Chargebacks',
                    scopeType: 'contract-manager',
                    permission: 'contract_manager.accounting.chargeback.list'
                },
            },
            {
                path: ':id',
                name: 'contractManager.chargebacks.detail',
                component: ChargebackDetail,
                meta: {
                    label: 'Chargeback Detail',
                    scopeType: 'contract-manager',
                    permission: 'contract_manager.accounting.chargeback.detail'
                },
            },
        ]
    },
]
